export default {
      id: "wedo-2-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#wedo-2",
      toString: function () {
        return this.url;
      }
    }